export default __webpack_public_path__ + "images/WS.8fa8726.png";